import { render, staticRenderFns } from "./AppearanceSettings.vue?vue&type=template&id=11704a36"
import script from "./AppearanceSettings.vue?vue&type=script&lang=ts"
export * from "./AppearanceSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports